import React from 'react';
import { ArcherGrid, GridProps } from '@archer-technologies/grid';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => {
  return {
    engageGridContainer: {
      marginTop: 12,
      '& [class*="MuiTypography-root"]': {
        fontSize: '0.875rem',
        fontFamily: ['Lato', 'Roboto', 'Oxygen', 'Helvetica Neue', 'sans-serif']
      },
      '& [class*="MuiTypography-h6"]': {
        fontWeight: 'bold',
        fontSize: '0.775rem'
      },
      '& [class*="MuiTableRow-root"]': {
        height: '24px !important'
      },
      '& [class*="MuiTableBody-root"]': {
        '& [class*="MuiTableCell-root"]': {
          padding: '12px 5px !important'
        },
        '& [class*="MuiTableCell-root"]:first-child': {
          paddingBottom: '12px !important'
        }
      }
    },
    hideToolbar: {
      '& [class*="MuiToolbar-root"]': {
        display: 'none'
      }
    }
  };
});

export interface EngageGridProps extends GridProps {
  translate: any;
  enableToolbar?: boolean; // Currently this just toggles visibility on the Toolbar since the ArcherGrid does not allow optionally displaying it
}

export const EngageGrid = (props: EngageGridProps) => {
  const { translate, columns, rows, enableToolbar } = props;
  const { engageGridContainer, hideToolbar } = useStyles();

  const handleTranslation = React.useCallback(key => translate(`engageGrid.${key.replace(/:/g, '.')}`), [translate]);

  const gridProps = {
    ...props,
    columns,
    rows,
    local: true,
    translate: handleTranslation
  };

  // actions?: Action[];
  // actionMessages?: any;
  // changeCurrentPage?: (currentPage: number) => void;
  // changePageSize?: (pageSize: number) => void;
  // checkOptions?: CheckProps;
  // columns: Column[];
  // columnExtensions?: Table.ColumnExtension[];
  // columnFilteringState?: ArcherGridColumnFiltering;
  // columnGroupingState?: ArcherGridColumnGrouping;
  // columnLocalSortingState?: ArcherGridColumnLocalSorting;
  // columnResizeEnabledNextColumn?: boolean;
  // columnSortingState?: ArcherGridColumnSorting;
  // columnVisibilityState?: Array<string>;
  // customActionType?: ActionPluginProps['customActionType']; // @DEPRECATED
  // defaultColumnVisibilityState?: Array<string>;
  // columnWidths?: TableColumnWidthInfo[];
  // defaultColumnWidths?: TableColumnWidthInfo[];
  // currentPage?: number;
  // dateOptions?: DateProps; // @DEPRECATED
  // dateTimeLocale?: any;
  // dateTimeLocaleCode?: string;
  // defaultPageSize?: number;
  // enableRowSelection?: boolean;
  // enableTreeView?: boolean;
  // enableVirtualTable?: boolean;
  // expandedGroups?: any;
  // filters?: ArcherGridFilter[];
  // filtersDefault?: ArcherGridFilter[];
  // grouping?: any;
  // groupingColumnExtensions?: GroupingState.ColumnExtension[];
  // images?: boolean;
  // imageValue?: string;
  // isAddNewEnabled?: boolean;
  // isEmailEnabled?: boolean;
  // isDeleteEnabled?: boolean;
  // isFilteringEnabled?: boolean;
  // isGroupingEnabled?: boolean;
  // isSortingEnabled?: boolean;
  // local?: boolean;
  // nestedTreeColumn?: string;
  // numberOptions?: NumberProps;
  // onAddNew?: (event: any) => void;
  // onColumnWidthsChange?: (nextColumnWidths: TableColumnWidthInfo[]) => void | undefined;
  // onEmailClick?: (event: any) => void;
  // onDeleteClick?: (event: any) => void;
  // onExpandedGroupsChange?: any;
  // onFiltersChange?: (filters: ArcherGridFilter[]) => void;
  // onGroupingChange?: any;
  // onRowSelection?: any;
  // onSortingChange?: (sorting: ArcherGridSorting[]) => void;
  // pageSize?: number;
  // pageSizes?: number[];
  // rows: Row[];
  // rowSelectionType?: selectionType;
  // showAddNew?: boolean;
  // showColumnChooser?: boolean;
  // showEmail?: boolean;
  // showDelete?: boolean;
  // showGroupingPanel?: boolean;
  // showFilteringButton?: boolean; // @DEPRECATED
  // showFilteringRow?: boolean; // @DEPRECATED
  // defaultSorting?: ArcherGridSorting[];
  // sorting?: ArcherGridSorting[];
  // showPagination?: boolean;
  // statuses?: StatusProps[];
  // totalCount?: number;
  // toolbarMenuItems?: ContextualMenuPopperMenuItem[];
  // translate?: any;
  // imagePath?: string;
  // setExpandedRowIds?: (value: any) => void;
  // expandedRowIds?: any;
  // getChildRows?: CustomTreeDataProps['getChildRows'];
  // getRowId?: (row: any) => React.ReactText;
  // gridToolbarActions?: GridToolbarAction[];

  return (
    <div className={`${engageGridContainer} ${enableToolbar ? '' : hideToolbar}`}>
      <ArcherGrid {...gridProps} />
    </div>
  );
};
